;var Navigation = (function( chapter ) {

  var isOpen = false;
  var locked = false;

  $('#navigation').on('click', function( e ) {
    if (locked) {
      return;
    }

    if ( isOpen ) {
      close();
    } else {
      open();
    }
  });

  function open() {
    isOpen = true;
    $( 'body' ).addClass( 'navigationOpen' );

    // dispatch event to be listen by every info button
    $(window).trigger('navigationOpenEvent');
  }

  function close() {
    isOpen = false;
    $( 'body' ).removeClass( 'navigationOpen' );
  }

  function lock() {
    locked = true;
  }

  function unlock() {
    locked = false;
  }

  return {
    open: open,
    close: close,
    lock: lock,
    unlock: unlock,
  }

})();
